import React from 'react';
import {
    Col, Row, Modal, FormControl, FormGroup, ControlLabel, Form
} from 'react-bootstrap';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';

class ModalAlta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: this.props.equipo ? this.props.equipo.nombre : null,
      idequipo: this.props.equipo ? this.props.equipo.id : null,
      descripcion: this.props.equipo ? this.props.equipo.descripcion : null,
      disponible: this.props.equipo ? this.props.equipo.disponible : true,
      error: false,
    };
    this.saveEquipo = this.saveEquipo.bind(this);
  }

  saveEquipo() {
    if (!this.state.nombre || this.state.nombre === '') {
      this.setState({error: true});
    } else {
      const equipo = {
        nombre: this.state.nombre,
        id: this.state.idequipo,
        descripcion: this.state.descripcion,
        devuelto: 1,
      }
      this.props.saveEquipo(equipo, this.props.closeModal);
    }
  }

  render() {
    return (
      <Modal show onHide={() => this.props.closeModal()} style={{ display: "block" }}>
        <ModalBlockWrapper
          content={
            <div>
              <Modal.Header closeButton>
                <Modal.Title>{this.props.equipo ? 'Editar Equipo' : 'Alta de Equipo'}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col md={12}>
                    <Form>
                      <FormGroup validationState={this.state.error ? 'error': null}>
                        <ControlLabel>{'Nombre'} </ControlLabel>
                        <FormControl
                          type="text" value={this.state.nombre ? this.state.nombre : ''}
                          onChange={(e) => this.setState({nombre: e.target.value, error: false})}
                          disabled={!this.state.disponible}
                        />
                      </FormGroup>
                    </Form>
                  </Col>
                  <Col md={12}>
                    <Form>
                      <FormGroup>
                        <ControlLabel>{'Descripcion'}</ControlLabel>
                        <FormControl
                          componentClass="textarea" type="text" style={{height: 120}}
                          value={this.state.descripcion ? this.state.descripcion : ''}
                          onChange={(e) => this.setState({descripcion: e.target.value})}
                          disabled={!this.state.disponible}
                        />
                      </FormGroup>
                    </Form>
                  </Col>
                  {!this.state.disponible &&
                    <Col md={12}>
                      <div style={{textAlign: 'center'}}>
                        <small>
                          Este equipo no puede ser editado porque actualmente se encuentra en uso
                        </small>
                      </div>
                    </Col>
                  }
                </Row>
              </Modal.Body>
              {this.state.disponible &&
                <Modal.Footer>
                  <Button simple onClick={this.props.closeModal}>
                    Cancelar
                  </Button>
                  <Button
                    bsStyle="success" fill onClick={this.saveEquipo}
                  >
                    Guardar
                  </Button>
                </Modal.Footer>
              }
            </div>
          }
        />
      </Modal>
    );
  }
}

export default ModalAlta;



// WEBPACK FOOTER //
// ./src/views/Administration/ModalAlta.jsx